import { render } from "./base_layout.vue?vue&type=template&id=271e9f8e"
import script from "./base_layout.vue?vue&type=script&lang=js"
export * from "./base_layout.vue?vue&type=script&lang=js"

import "./base_layout.vue?vue&type=style&index=0&id=271e9f8e&lang=less"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\wxPrint2\\adminVue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__